import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=35d9bbb9"
import script from "./TrainDetail.vue?vue&type=script&lang=js"
export * from "./TrainDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainDetail.vue?vue&type=style&index=0&id=35d9bbb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports